export default {
  negocioPropio: null,
  negocioPropioObj: null,
  restPropio: null,
  restPropioObj: null,
  listadoRestaurantes: [],
  listadoRestNegMix: [],
  esconderLogo: false,
  redesSociales: [
    { icon: "fab fa-facebook", url: "https://es-es.facebook.com/Padthaiwok" },
    { icon: "fab fa-twitter", url: "https://twitter.com/padthaiwok/" },
    // { icon: "fab fa-google-plus", url: ""},
    // { icon: "fab fa-linkedin", url: ""},
    { icon: "fab fa-instagram", url: "https://www.instagram.com/padthaiwok/" }
  ]
}